'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'clock';
var width = 512;
var height = 512;
var aliases = [128339,"clock-four"];
var unicode = 'f017';
var svgPathData = ['M0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zM232.1 117.5c.1-.8 .2-1.6 .4-2.4 .3-1.6 .8-3.1 1.4-4.5 1.2-2.9 3-5.5 5.1-7.6 4.3-4.3 10.3-7 17-7 13.3 0 24 10.7 24 24l0 123.2c28.4 19 56.9 37.9 85.3 56.9 11 7.4 14 22.2 6.7 33.3s-22.3 14-33.3 6.7c-32-21.3-64-42.7-96-64-3.3-2.2-6-5.2-7.8-8.6-.9-1.7-1.6-3.5-2.1-5.4-.2-1-.4-1.9-.5-2.9-.1-.5-.1-1-.1-1.5s0-.9 0-1.5c0-45.3 0-90.7 0-136.3 0-.6 0-1.4 .1-2.2z', 'M256 96c-13.3 0-24 10.7-24 24l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faClock = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;